module.exports = __webpack_public_path__ + "static/media/contact.6c1ae266.JPG";